import React from "react";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import clsx from "clsx";
import styles from "./style/AboutTab.module.css";
import { uniqueId } from "lodash";

const AboutTab = (props) => {
  const { requirements, description, benefits } = props;

  const renderListItem = (item, index) => {
    return (
      <div key={item + index} className={clsx("d-flex mb-2", styles.listItem)}>
        <i className="bi bi-check-circle-fill mr-3"></i>
        <li>{item}</li>
      </div>
    );
  };

  const benefitList = benefits ? benefits.trim().split("\n") : [];
  const middleIndex = benefitList.length
    ? Math.ceil(benefitList.length / 2)
    : 0;

  return (
    <Container fluid className={clsx("p-0 py-5", styles.container)}>
      <div>
        <h4>Requirements</h4>
        <ul className={styles.requirementList}>
          {requirements &&
            requirements
              .trim()
              .split("\n")
              .map((item) => <li key={uniqueId()}>{item}</li>)}
        </ul>
      </div>
      <div>
        <h4>Description</h4>
        <div>{ReactHtmlParser(description.trim())}</div>
      </div>
      <div className={clsx(styles.thingsWillLearn, "border rounded p-4")}>
        <h4>What you&apos;ll learn</h4>
        <ul className={clsx(styles.listContainer, "row p-0 m-0")}>
          <div className={clsx("col-12", benefitList.length > 1 && "col-md-6")}>
            {benefitList
              .slice(0, middleIndex)
              .map((item, index) => renderListItem(item, index))}
          </div>
          <div className="col-12 col-md-6">
            {benefitList
              .slice(middleIndex)
              .map((item, index) => renderListItem(item, index))}
          </div>
        </ul>
      </div>
    </Container>
  );
};

/* required: display name */
AboutTab.displayName = "AboutTab";

/* required: props types */
AboutTab.propTypes = {
  requirements: PropTypes.string,
  description: PropTypes.string,
  benefits: PropTypes.string,
};

/* required: default props */
AboutTab.defaultProps = {
  requirements: "",
  description: "",
  benefits: "",
};

export { AboutTab };
